import React from "react";
import Vimeo from "@u-wave/react-vimeo";
import "../../style/Home.css";
import { useAppContext } from '../../AppContext';
import parse from 'html-react-parser';


export default function Video() {
  const { globalState, setGlobalState } = useAppContext();

  if (!globalState.title || !globalState.descripcionVideo || !globalState.vimeo) {
    return <div>Cargando...</div>;
  }

  const handleChangeEnd = () => {
    setGlobalState({
      ...globalState,
      aditionalNavbar:true,
      finVimeo:true
    })
  }
  return (
    <>
      <div className="video-container">
        <div className="spacer">
        <div className="video-description">
            <p className="custom-description title">{globalState.title}</p>
            <p className="custom-description subtitle">
            {parse(globalState.descripcionVideo)}
            </p>
        </div>
        <div className="video-body">

          {globalState.vimeo !== "" &&  <Vimeo
            video={globalState.vimeo}
            autoplay
            controls={true}
            keyboard={false}
            responsive={window.matchMedia("(min-width: 800px)").matches ? false : true}
            width={window.matchMedia("(max-width: 800px)").matches ? "" : 
            window.matchMedia("(max-width: 900px)").matches ? "750" : 
            window.matchMedia("(max-width: 1100px)").matches ? "900" : 
            window.matchMedia("(max-width: 1200px)").matches ? "1000" : 
            window.matchMedia("(max-width: 1500px)").matches ? "1100" : 
            window.matchMedia("(max-width: 1800px)").matches ? "1500" : 
            "1500"}
            height={window.matchMedia("(max-width: 800px)").matches ? "" : 
            window.matchMedia("(max-width: 900px)").matches ? "500" : 
            window.matchMedia("(max-width: 1100px)").matches ? "600" :
            window.matchMedia("(max-width: 1200px)").matches ? "650" :  
            window.matchMedia("(max-width: 1500px)").matches ? "600" :
            window.matchMedia("(max-width: 1800px)").matches ? "800" :    
            "800"}
            volume={1}
            onEnd={() => handleChangeEnd()}

          />}
        </div>

        <div className="bottom-appbar">
            <p className="custom-description videofooter">
            {parse(globalState.finalMessage)}
            </p>
        </div>
        </div>
      </div>
    </>
  );
}
